<div class="modal-header">
  <h3 class="modal-title">
    {{ idleService.idleState === IdleStateTypes.warning ? 'You Appear To Be Inactive.' : 'Your Session Has Expired.' }}
  </h3>
</div>
@if (idleService.idleState === IdleStateTypes.warning) {
  <div idle-countdown="countdown" class="modal-body idle-dialog-content">
    <p>
      <strong>Are you still using your Self-Service Portal?</strong> Due to inactivity, you will be automatically logged
      out in <strong>{{ idleService.countdown }}</strong> second(s).
    </p>
  </div>
}
@else {
  <div idle-countdown="countdown" class="modal-body idle-dialog-content">
    <p>
      Due to inactivity and to help prevent unauthorized use of your account, you have been logged out of the
      Self-Service Portal.
    </p>
  </div>
  <div class="modal-footer">
    <app-button id="btnDismiss" (clickActionEmitter)="continue()" label="Dismiss" buttonStyle="secondary"> </app-button>
  </div>
}
